<template>
<div>
  <v-layout row>
    <h2 class="besetblue--text ml-2 mt-2"> besea </h2>
    <v-spacer/>
    <v-btn outline small color="besetblue" :to="'/signup'">
      sign up
    </v-btn>
  </v-layout>
  <v-content>
    <section>
      <v-layout>
         <v-flex xs12 sm8 offset-sm2>
           <v-card>
             <v-card-title primary-title>
               <div>
                 <h3 class="headline mb-0">Data Privacy Agreement</h3>
                 <div>
                   <v-layout row class="ml-2 mt-4">
                     1.	All data you generate must be accurate, up to date, and complete.
                   </v-layout>
                   <v-layout row class="ml-2">
                     2.	We will not share your data with third party for commercial or advertising benefit.
                   </v-layout>
                   <v-layout row class="ml-2">
                     3.	Your data will not be used in direct or indirect marketing.
                   </v-layout>
                   <v-layout row class="ml-2">
                     4.	You accept that all your data may be viewed by System Administrator or Facility Owner to which you signed up access.
                   </v-layout>
                   <v-layout row class="ml-2">
                     5.	Your data will not be modified by Database Administrator.
                   </v-layout>
                   <v-layout row class="ml-2">
                     6.	You must not use other username even if user granted the permission.
                   </v-layout>
                   <v-layout row class="ml-2">
                     7.	You must not share your data, or data specific to the Company or Facility to other parties.
                   </v-layout>
                   <v-layout row class="ml-2">
                     8.	You must use the data responsibly, do not publish data which may be offensive, sensitive to data privacy or disrespectful.
                   </v-layout>
                   <v-layout row class="ml-2">
                     9.	You must not attempt circumvent established security systems.
                   </v-layout>
                   <v-layout row class="ml-2">
                     10.	You may cancel your account at any time.
                   </v-layout>
                   <v-layout row class="ml-2">
                     11.	Your account may be suspended by the System Administrator if the activity is not compliant with the internal company regulations.
                   </v-layout>
                   <v-layout row class="ml-2">
                     12.	Your account may by restrict by Database Master Key holder if the activity is deemed suspicious or in contradiction with data privacy.
                   </v-layout>
                   <v-layout row class="ml-2">
                     13.	Any updates to the Data Privacy or Software Licence will be communicated to you and in some cases written or digital signature may to continue services.
                   </v-layout>
                   <v-layout row class="ml-2">
                     14.	You must not copy or publish unique web forms exclusively developed for unique Facility.
                   </v-layout>
                   <v-layout row class="ml-2">
                     15.	All services provided are at your own risk. Your hold entire risk of using the services.
                   </v-layout>
                   <v-layout row class="ml-2">
                     16.	Strong report culture is expected, you must report any fault or unexpected performance.
                   </v-layout>
                   <v-layout row class="ml-2">
                     17.	The company will take any reasonable steps to protect data from misuse or interference, or unauthorised access.
                   </v-layout>
                 </div>
               </div>

             </v-card-title>

             <v-card-actions>
               <!-- <v-btn flat color="orange">Share</v-btn> -->
               <!-- <v-btn flat color="orange">Explore</v-btn> -->
             </v-card-actions>
           </v-card>
         </v-flex>
      </v-layout>
    </section>


    <PublicFooterPage/>

  </v-content>
</div>
</template>


<script>
/* eslint-disable */
import InfoCard from "../components/InfoCard"
import PublicFooterPage from "../components/PublicFooterPage"

export default {
  components: {
    InfoCard,
    PublicFooterPage
  },
  data() {
    return {
      currentPagePath: "/about",
      InfoCard1: {
        title: "Reliability",
        icon: "settings",
        text: "Effective maintenance strategies will enable to complete the right maintenance at the right time. The best in class management of test results can achieve maintenance optimisation or reliability increase for the facility."
      },
      InfoCard2: {
        title: "Mission",
        icon: "data_usage",
        text: "Provider of outstanding facility and asset results management software platform. State of the art secure database with advanced analytics to enable the asset owners to improve plant reliability and reduce total life cycle cost."
      },
      InfoCard3: {
        title: "Vision",
        icon: "public",
        text: "Asset management platform using real time databases, in development artificial intelligence and automated data collection of test and inspection results. Empowering asset owners to enable quality key business decisions on asset reliability and life extension."
      }
    };
  }
};
</script>
